/**
 * @generated SignedSource<<8a9be46356578ecb87247500d0caed13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraAnnouncementBannerVisibility = "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type BannerAnnouncement$data = {
  readonly announcementBanner: {
    readonly isDismissible: boolean | null | undefined;
    readonly message: string | null | undefined;
    readonly visibility: JiraAnnouncementBannerVisibility | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "BannerAnnouncement";
};
export type BannerAnnouncement$key = {
  readonly " $data"?: BannerAnnouncement$data;
  readonly " $fragmentSpreads": FragmentRefs<"BannerAnnouncement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "BannerAnnouncement",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraAnnouncementBanner",
      "kind": "LinkedField",
      "name": "announcementBanner",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isDismissible"
        },
        {
          "kind": "ScalarField",
          "name": "message"
        },
        {
          "kind": "ScalarField",
          "name": "visibility"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "4e27aa9b6c5468ae3485ff5718ab32dc";

export default node;
